<template>
    <section>
      
      <div class="boxx">
        
        <h3 class="title is-5 has-text-centered"></h3>
        <div class="columns">
          
          
          <div class="column is-4" >
            <b-message type="is-info" title="How to setup" v-if="modelType == 'classification'">
            1. Input the desired text on the input box <br>
            2. LLM will run and fill the predicted box with your predicted labels.<br>
            3. The text sample and LLM's prediction will be used to train a smaller model.
            </b-message>
            <b-message type="is-info" title="How to setup" v-if="modelType == 'extraction'">
            1. Input the desired text on the input box <br>
            2. LLM will run and fill the predicted box with your predicted tags.<br>
            3. The text sample and LLM's prediction will be used to train a smaller model.
            </b-message>
            <div class="box">
              <b-field label="Classify labels" v-if="modelType == 'classification'">
                <b-taginput
                  @input="updatePromptModel"
                  size="is-medium"
                  type="is-info"
                  expanded
                  v-model="labels"
                  :allow-new="true"
                  :open-on-focus="true"
                  placeholder="➕ Add a label">
                </b-taginput>
              </b-field>
              <b-field label="Strategy" :message="multiLabel ? 
                    'Each input will have multi output label' : 
                    'Each input will have only one output label'" v-if="modelType == 'classification'">
                
                <b-switch @input="updatePromptModel" v-model="multiLabel" type="is-info" expanded>
                  {{ multiLabel ? 'Multi-label' : 'Multi-class' }}
                </b-switch>
                
              </b-field>
              <b-field label="Extract tags"  v-if="modelType == 'extraction'">
                <b-taginput
                  @input="updatePromptModel"
                  size="is-medium"
                  type="is-info"
                  expanded
                  :data="['location', 'names', 'date', 'time']"
                  v-model="labels"
                  :allow-new="true"
                  :open-on-focus="true"
                  placeholder="➕ Add a tag">
                </b-taginput>
              </b-field>
              <!-- <b-field label="Describe your task">
                <b-input
                  @input="updatePromptModel"
                  size="is-medium"
                  type="textarea"
                  expanded
                  v-model="instruction"
                  rows="3"
                  required
                  autocomplete="true"
                  placeholder="e.g., Describe the domain, context and the desired output">
                </b-input>
              </b-field>
              <b-field label="Foundation Model" message="Ability to understand complex patterns in data">
                <b-select @input="updatePromptModel" v-model="modelSize" size="is-mediumx" placeholder="Select a model size" expanded>
                  
                    <option value="small">RoBERTa 125M</option>
                    <option value="medium">
                        Phi-2 2.7B
                    </option>
                    <option value="large" :disabled="userPlan != 'pro'">
                        LLama 2 13B
                        <b-tag v-if="userPlan != 'pro'" type="is-dark">(Available on PRO plan)</b-tag>
                  </option>
                  <option value="mistral" disabled>Mistral 7B (Coming soon)</option>
                  <option value="mistral" disabled>LLama 2 70B (Coming soon)</option>
                </b-select>
                
              </b-field> -->
              <br>
              
            </div>
            
            
          </div>
          
          
          
          <div class="column is-8">
            <section class="hero is-white">
              <div class="box">
                <div class="">
                    <b-tooltip type="is-dark" position="is-left" multilined>
                        
                        <i class="fa fa-info-circle"></i>
                        
                        <template v-slot:content>
                            <span>
                                <b>1. Input your text </b> here you will input the desired text.
                                <br>
                                <b>2. Run test</b> run tests based on the input text you insert on the box.
                                <br>
                                <b>3. Results</b> on predict box, you can check how it scored based on what you have been defined.
                            </span>
                        </template>
                    </b-tooltip>
                  <b-field label="Text sample">
                    <b-input
                      style="border: none; box-shadow: none; border-radius: 0;"
                      size="is-medium"
                      maxlength="2000"
                      expanded
                      rows="5"
                      required
                      autocomplete="true"
                      type="textarea"
                      v-model="text"
                      placeholder="Type your text here">
                    </b-input>
                  </b-field>
                  <p class="control">
                    <b-button class="is-pulled-right" @click="runInference" size="is-medium" type="is-primary">✨ Run test</b-button>
                  </p>
                  
                </div>
              </div>
            </section>
            <br>
            <div class="box">
            
              <b-tooltip type="is-dark" position="is-left" multilined>
                    
                    <i class="fa fa-info-circle"></i>
                    
                    <template v-slot:content>
                        <span>
                            Here you can check the predicted results.
                            <br>
                            You will see how good it scored and if wanted, add or delete and run again
                        </span>
                    </template>
                </b-tooltip>
                
            <b-field label="Predict"></b-field>
              <div class=" xbox" ref="inference_result">
                <span v-if="inference_result && modelType == 'extraction'">
                    <!-- <TextAnnotation
                    :key="`playground${text}`"
                    :text="text" 
                    v-model="inference_result"
                    :labels="labels.map((item, index) => ({ label: item, id: index }))"
                    :readonly="false"/> -->
                    
                    <div v-html="highlight(inference_result)"></div>
                    &nbsp;
                </span>
                <span v-else-if="inference_result ">
                    <b-taglist>
                        <b-tag :type=" item.score > 0.5 ? `is-dark` : `is-white`" size="is-medium" v-for="(item, index) in inference_result">
                                {{  item.label }} ({{ parseFloat(item.score).toFixed(2) }})
                        </b-tag>
                    </b-taglist>

                    <!-- <b-field
                        grouped
                        group-multiline>
                    <p class="control" v-for="(label, score) in labels.map((item, index) => ({ label: item, score: 1 }))">
                        <b-checkbox-button
                            style="margin-right: 0.2em"
                            type="is-info is-light"
                            v-model="inference_result"
                            :native-value="label">
                            {{ label.label }}
                        </b-checkbox-button>
                        
                    </p>
                    </b-field> -->
                    &nbsp;
                </span>
                <span v-else>
                  <b>Provide a text sample and define labels to test results</b>
                </span>
              </div>

              
              
            </div>
          </div>
          
        </div>
      </div>
      
      
    </section>
    
    
    
  </template>
  
  
  <script>
    
    import TextAnnotation from 'ner-text-annotation';
    export default {
      props: {
        modelType: String,
        userPlan: String,
        project: Object
      },
      data() {
        return {
          text: '',
          modelSize: "small", // small 7B Mistral, medium, large 70B LLama
          multiLabel: true,
          labels: [],
          try_records: [],
          isInference: false,
          inference_result: null,
          data: [],
          columns: [ {
            field: 'label',
            label: 'Label',
            
          },
          {
            field: 'score',
            label: 'Score',
            numeric: true
          }
          ]
        }
      },
      components:{
        TextAnnotation
      },
      watch: {
        modelType: function (val) {
          this.onModelTypeChange()
        },
        labels: function (val) {
          this.updateLabels()
        }
      },
      methods: {
        insertAsRecord(){
            let record = {
                text: this.text,
                labels: this.modelType == 'classification' ? this.inference_result.filter( i => i.score > 0) : [],
                tags: this.modelType == 'extraction' ? this.inference_result.filter( i => i.score > 0) : []
            }

            this.$store.dispatch(
                "addRecord",
                    {   text: record.text, 
                        labels: record.labels || [], 
                        tags: record.tags || [],
                        projectId: this.project.id,
                        datasetId: this.project.datasetId
                    }
            ).then( (res) => {
                this.$store.dispatch('getRowsByDataset', this.project.datasetId)
            })
        },
        updateLabels(){
          this.$emit('updateLabels', this.labels)
        },
        updatePromptModel(){
          this.$emit('updatePromptModel', {
            labels: this.labels, 
            modelSize: this.modelSize,
            multiLabel: this.multiLabel,
            instruction: this.instruction
            })
        },
        onModelTypeChange(){
          let textByTask = {
            classification: 'This product have a good quality, delivery is nice and arrived in 2 days!',
            extraction: 'John Doe works at ABC Corporation in New York. The event will be held at 9:00 AM on May 20, 2023.',
            generation: "Type prompt here"
          }
          
          let labelsByTask = {
            classification: ['delivery time', 'customer support', 'product quality', 'company reputation', 'product information', 'shop experience'],
            extraction: ['person', 'organization', 'location', 'time', 'date'],
            generation: []
          }
          
          let resultByTask = {
            classification: [
                {"label": 'delivery time', "score": 1.0 },
                {"label": 'product quality', "score": 1.0 },
                {"label": 'customer support', "score": 0.0 },
                {"label": 'company reputation', "score": 0.0 },
                {"label": 'product information', "score": 0.0 },
                {"label": 'shop experience', "score": 0.0 }
            ],
            extraction: [
              {'text': 'John Doe', 'label': 'person', 'start': 0, 'end': 8},
              {'text': 'ABC Corporation', 'label': 'organization', 'start': 22, 'end': 37},
              {'text': 'New York', 'label': 'location', 'start': 41, 'end': 49},
              {'text': '9:00 AM', 'label': 'time', 'start': 63, 'end': 69},
              {'text': 'May 20, 2023', 'label': 'date', 'start': 73, 'end': 85}
            ],
            generation: ["test result for generation"]
          }
          
          this.text = textByTask[this.modelType]
          
          this.labels = labelsByTask[this.modelType]
          
          this.inference_result = resultByTask[this.modelType]
          this.instruction = "Type your instruction here"
          
          this.updatePromptModel()
          
        },
        highlight(result) {
          
          if (!result || result == 'no prediction') return this.text;
          
          if(this.modelType != 'extraction') {
            return result;
          }
          
          let highlight = []
          let highlight_text = ''
          result.forEach(async (r) => {
            let span = this.text.substring(r.start, r.end)
            highlight_text = `<span style="margin-bottom: 5px" data-entity="${r.label.toLowerCase()}">${span}&nbsp;<span class='entities-type'><b>${r.label}</b></span></span>`;
            
            highlight.push(highlight_text)
          });
          
          return highlight.join(' ')
        },
        runInference(){
          this.updatePromptModel()
          let isFullPage = false
          this.isInference = true
          this.data = []
          const loadingComponent = this.$buefy.loading.open({
            container: isFullPage ? null : this.$refs.inference_result.$el
          })
          
          this.$store.dispatch(
            "getPreBuildModelInference",
            {text: this.text, labels: this.labels, multilabel: this.multiLabel, modelId: this.modelType, instruction: this.instruction}
          ).then( (prediction) => {
            this.isInference = false
            this.inference_result = prediction
            // this.addData(res.prediction)
            
            loadingComponent.close()

            this.insertAsRecord()
            
          })
        },
        // addData(prediction){
        //   this.data = []
        //   // get index
        //   prediction.forEach((item, i) => {
        //     this.data.push({
        //       label: item.label,
        //       score: parseFloat(item.confidence).toFixed(2)
        //     })
        //   });
          
        // },
        addAsRecords(text, res){
          this.try_records.push({
            id: null,
            text: text,
            labels: res,
            createdAt: new Date().getTime()
          })
        }
      },
      mounted() {
        
        this.onModelTypeChange()
        
      }
    }
  </script>
  <style>
    
  </style>